import SpriteSymbol from "../../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "close",
  "use": "close-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 1024 1024\" id=\"close\">\n<path d=\"M1020.064 55.136l-55.136-55.136-456.864 456.864-441.12-448.992-55.136 63.008 441.12 441.12-448.992 456.864 55.136 55.136 448.992-456.864 448.992 448.992 55.136-55.136-441.12-448.992z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol